import { isEmpty } from 'lodash';
import { apiService } from 'adapters/apiService';
import {
  API_ERROR_MSG,
  LOCK_STATUS_MAP,
  METHOD,
  PATHS
} from 'adapters/constants';
import {
  AuthorizePaymentInvoice,
  LockInvoiceResponse,
  LockStatus
} from '../../pages/AuthorizePaymentPage/types';
import type { HeaderData } from 'adapters/types';

export const updateInvoiceLockStatus = async (
  invoices: AuthorizePaymentInvoice[],
  headers: HeaderData,
  storeId: string,
  lockStatus: LockStatus
): Promise<LockInvoiceResponse> => {
  if (isEmpty(storeId)) {
    throw new Error(API_ERROR_MSG.MISSING_STORE_ID);
  }
  const response = await apiService({
    url: `${PATHS.getLockInvoices()}/${LOCK_STATUS_MAP[lockStatus]}`,
    method: METHOD.PATCH,
    reqObj: invoices,
    headers: { ...headers, 'x-store-id': storeId }
  });
  if (!response?.ok) throw new Error(response.statusText);
  return response.json() as Promise<LockInvoiceResponse>;
};
